import { QRCodeSVG } from "qrcode.react";

/**
 * Industrial-styled scan card with a real, working QR code.
 *
 * The QR auto-resolves to the current site's origin (window.location.origin)
 * so it works on the preview, emergent.host, AND a custom domain like
 * hurricanecuts.com — no code changes needed when the domain switches.
 *
 * Variants:
 *  - "dark"  — black card on light background (used on light sections)
 *  - "light" — light card on dark background (used on dark sections)
 *  - "compact" — small footer-friendly tile
 */
export default function QRCard({
  url,
  label = "Scan to visit Hurricane Cuts",
  sub = "Save us in your contacts",
  variant = "dark",
  size = 160,
  testId = "qr-card",
}) {
  const resolvedUrl =
    url ||
    (typeof window !== "undefined" && window.location?.origin) ||
    "https://hurricanecuts.com";
  if (variant === "compact") {
    return (
      <div
        data-testid={testId}
        className="bg-white border-2 border-[#0B1810] p-3 inline-flex flex-col items-center gap-2 shadow-[4px_4px_0_#FF5A00]"
      >
        <QRCodeSVG
          value={resolvedUrl}
          size={size}
          bgColor="#FFFFFF"
          fgColor="#0B1810"
          level="M"
          includeMargin={false}
        />
        <div className="font-accent text-[10px] tracking-[0.18em] uppercase text-[#0B1810] text-center max-w-[160px] leading-tight">
          {label}
        </div>
      </div>
    );
  }

  if (variant === "light") {
    return (
      <div
        data-testid={testId}
        className="bg-[#F4F1EA] border-2 border-[#FF5A00] p-5 inline-flex flex-col items-center gap-3 shadow-[6px_6px_0_#FF5A00]"
      >
        <div className="bg-white p-3">
          <QRCodeSVG
            value={resolvedUrl}
            size={size}
            bgColor="#FFFFFF"
            fgColor="#0B1810"
            level="M"
            includeMargin={false}
          />
        </div>
        <div className="text-center">
          <div className="font-heading text-xl tracking-wider text-[#0B1810] leading-tight">
            {label}
          </div>
          {sub && (
            <div className="font-accent text-[10px] tracking-[0.2em] uppercase text-[#FF5A00] mt-1">
              {sub}
            </div>
          )}
        </div>
      </div>
    );
  }

  // dark (default)
  return (
    <div
      data-testid={testId}
      className="bg-[#0B1810] border-2 border-[#FF5A00] p-5 inline-flex flex-col items-center gap-3 shadow-[6px_6px_0_#FF5A00] text-white"
    >
      <div className="bg-white p-3">
        <QRCodeSVG
          value={resolvedUrl}
          size={size}
          bgColor="#FFFFFF"
          fgColor="#0B1810"
          level="M"
          includeMargin={false}
        />
      </div>
      <div className="text-center">
        <div className="font-heading text-xl tracking-wider text-white leading-tight">
          {label}
        </div>
        {sub && (
          <div className="font-accent text-[10px] tracking-[0.2em] uppercase text-[#FF5A00] mt-1">
            {sub}
          </div>
        )}
      </div>
    </div>
  );
}
